import { UseMutationOptions } from '@tanstack/react-query';

import { ENTITY_TYPES } from 'features/challenge/config';
import {
  ChallengeParameters,
  ChallengesPostType,
} from 'features/challenge/config/types';
import { useCreateChallengeModal } from 'features/challenge/hooks/useCreateChallengeModal';
import { IPlanningDraftSprint } from 'features/planning';

import {
  ChallengeWithId,
  useCreateCustomChallengesMutation,
} from './mutation/useCreateCustomChallenges';

type TUseCreateCustomChallenge<TChallengeType> = {
  sprint: IPlanningDraftSprint;
  options?: UseMutationOptions<
    { challenges: TChallengeType[] },
    Error,
    ChallengesPostType<TChallengeType>,
    { challenges: TChallengeType[] }
  >;
  parameters?: ChallengeParameters;
};

export const useAddCustomChallenge = <TChallengeType extends ChallengeWithId>({
  sprint,
  options,
  parameters,
}: TUseCreateCustomChallenge<TChallengeType>) => {
  const { mutateAsync: addChallenge } =
    useCreateCustomChallengesMutation<TChallengeType>({
      options,
    });

  //@ts-ignore
  const openAddChallengeModal = useCreateChallengeModal<TChallengeType>({
    mutateFunc: async (challenge: TChallengeType) => {
      await addChallenge({
        challenges: challenge,
        parameters: {
          ...parameters,
          // @ts-ignore
          asRoutine: challenge?.entityType === ENTITY_TYPES.ROUTINE,
        },
      });
    },
    sprint,
  });

  return openAddChallengeModal;
};
